const errorMap: Record<string, string> = {
  INVALID_SYMBOLOGY: "The provided symbology is not supported yet.",
  CAMERA_PERMISSION_DENIED: "Please allow camera access to use the scanner.",
  CAMERA_ERROR: "An error occurred while accessing the camera.",
  QR_CODE_NOT_SUPPORTED:
    "Not all QR codes are supported yet, support is coming soon.",
  ARTICLE_ALREADY_EXISTS: "This article has already been added.",
};

export const formatScannerErrors = (error: string): string => {
  return errorMap[error] || "Something went wrong";
};
